import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// component
import { LoadingScreen } from "../../component/loading";
import { routePublict } from "./route/router_publict";
import { routerPrivate } from "./route/router_private";
import { useLogged } from "hook/useLogged";
import TermOfService from "screen/99_Term/term_of_service";
import DataPrivacy from "screen/98_Data_Privacy/data_privacy";
import { URL } from "./url";
import HomeScreen from "screen/01_Home/home_screen";
import { useSelector } from "react-redux";
import { onboardHasSelector } from "store/bailiff/onboard/onboard.selector";
// redux

const Router = () => {
  // -------------------------- STATE ---------------------------
  const { logged } = useLogged();

  // -------------------------- REDUX ---------------------------
  const onboard = useSelector(onboardHasSelector);
  const urlList = !onboard ? URL.list + `?viewOnboard=true` : URL.list;
  const to = logged ? urlList : URL.home;
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- MAIN ----------------------------
  if (logged === null) {
    return <LoadingScreen />;
  }
  return (
    <BrowserRouter>
      <Routes>
        {logged ? routerPrivate() : routePublict()}
        <Route path={URL.home} element={<HomeScreen />} />
        <Route path={URL.term} element={<TermOfService />} />
        <Route path={URL.privacy} element={<DataPrivacy />} />
        <Route path="*" element={<Navigate to={to} exact replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
